import { render } from "./AdminAccount.vue?vue&type=template&id=306fb440&scoped=true"
import script from "./AdminAccount.vue?vue&type=script&lang=js"
export * from "./AdminAccount.vue?vue&type=script&lang=js"

import "./AdminAccount.vue?vue&type=style&index=0&id=306fb440&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-306fb440"]])

export default __exports__